import { Linkedin, Twitter, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-[#030712] py-16 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_doc-breakdown/artifacts/t51v67ke_LighV.png"
                alt="Management To Learn USA LLC"
                className="h-14 w-auto object-contain"
              />
            </Link>
            <p className="text-white/40 text-sm leading-relaxed mb-6">
              Building global pathways for learning, leadership, and innovation 
              across continents since 2013.
            </p>
            <div className="flex gap-4">
              {[Linkedin, Twitter, Mail].map((Icon, idx) => (
                <a
                  key={idx}
                  href="#"
                  className="w-10 h-10 glass-card rounded-lg flex items-center justify-center hover:bg-primary/20 hover:border-primary/30 transition-all"
                >
                  <Icon className="w-5 h-5 text-white/50 hover:text-primary" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { href: "/", label: "Home" },
                { href: "/about", label: "About" },
                { href: "/services", label: "Services" },
                { href: "/heritage", label: "Heritage" },
                { href: "/contact", label: "Contact" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/40 hover:text-primary transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Heritage */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-6">Heritage</h4>
            <ul className="space-y-3">
              {[
                { href: "/heritage", label: "Our Story" },
                { href: "/heritage/timeline", label: "Timeline" },
                { href: "/heritage/archive", label: "Photo Archive" },
                { href: "/transition", label: "What's New" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/40 hover:text-secondary transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Global Presence */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-6">Global Presence</h4>
            <ul className="space-y-3">
              {[
                "North America",
                "Europe",
                "Asia Pacific",
                "Latin America",
                "Africa",
              ].map((region) => (
                <li key={region}>
                  <span className="text-white/40 text-sm">{region}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-sm">
            © 2025 Management To Learn USA LLC. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/transition" className="text-white/30 hover:text-primary text-sm transition-colors">
              What's New
            </Link>
            <a href="#" className="text-white/30 hover:text-primary text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-white/30 hover:text-primary text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
